import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render turnover section for FAQ Page
 */
const Turnover = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="turnover-component"
    >
      <AccordionV2
        testId="launch"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="If a company's turnover is high, is it expected to be ranked high as well?"
            className="px-0 font-medium"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <p className="m-0 px-6 pb-2 pt-4">
          In ranking the top 50 companies, we look at factors which would
          reflect a company&apos;s enterprising spirit. Turnover is only one of
          many factors - growth and vision to venture internationally, as well
          as knowledge management skills are examples of other areas we
          consider.
        </p>
      </AccordionV2>
    </div>
  );
};

export default Turnover;
